import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { EnrichedUser } from '../../models/user.models';
import { UserDisplayPipe } from '../../pipes/user-display.pipe';
import { UserGroupPipe } from '../../pipes/user-group.pipe';

@Component({
  selector: 'app-user-list-item',
  templateUrl: './user-list-item.component.html',
  styleUrls: ['./user-list-item.component.scss'],
  imports: [MaterialModule, UserDisplayPipe, RouterModule],
  providers: [UserGroupPipe],
})
export class UserListItemComponent {
  @Input() user: EnrichedUser;
  @Input() clients: string[];
  @Input() isSelected: boolean;

  constructor(private userGroupPipe: UserGroupPipe) {}

  get userGroupsText() {
    return this.user.user_groups
      .map(({ key }) => this.userGroupPipe.transform(key))
      .sort()
      .join(' | ');
  }
}
